import { css } from '@emotion/react';
import React from 'react';
import SPImage from '../image/SPImage';
import InfoPopupContainer from './container/InfoPopupContainer';
import placeholder from 'public/assets/placeholder_banner.png';

interface ICharacterProfilePopup {
  characterProfile?: {
    title: string;
    imageUrl?: string | undefined;
  };
  isShow: boolean;
  onClose: () => void;
}

const CharacterProfilePopup = ({
  characterProfile,
  isShow = false,
  onClose,
}: ICharacterProfilePopup) => {
  if (!isShow) {
    return null;
  }

  return (
    <InfoPopupContainer title={characterProfile?.title} onClose={onClose}>
      <div css={container}>
        <SPImage
          src={characterProfile?.imageUrl || placeholder}
          width={700}
          height={700}
          alt="Character image"
          objectFit="cover"
        />
      </div>
    </InfoPopupContainer>
  );
};

const container = css`
  margin-top: 1em;
`;

export default CharacterProfilePopup;
